import { convertRemToPx } from '@hivebrite/design-system/Theme';

import { getLastFrameAttributes } from 'hb-builder/components/BuilderComponents/page/block/Strips/utils/getLastFrameAttributes';
import { createNewItem } from 'hb-builder/utils/createNewItem';

const placeholder = [
  'Accusamus autem rerum tempore eligendi ducimus eligendi. Est aut sequi vitae molestiae. Rerum et nulla minima fuga asperiores. Accusamus numquam dolores est dolorem quaerat aperiam optio sunt deleniti.',
  __('Subtitle goes here'),
  'repellendus quisquam qui enim dolor unde illum ratione repudiandae quia in tenetur rem maxime ut odit assumenda et et ut ea quis ut non quas odit voluptatem ad laudantium alias id impedit aut aut possimus veritatis quae qui maxime nulla ea aperiam sunt voluptatem quia perferendis est',
  'Qui consequatur voluptas dolor. Sint libero laboriosam rerum eligendi eveniet nulla hic dolorem dolor. Corrupti aliquam eveniet corrupti eum. In totam natus eum laboriosam harum quia animi sint aut.',
];

export const getStripItemChildren = (props) => {
  const {
    components,
    featureFlags,
    features,
    stripsItem,
    theme,
    ...otherProps
  } = props;
  const { image, index } = otherProps;
  const { Button, Text } = components;
  const placeholderIndex = index % 4;

  const {
    headlineAttributesToApply,
    sublineAttributesToApply,
    buttonAttributesToApply,
  } = getLastFrameAttributes(stripsItem);

  const headline = Text.item({
    ...props,
    features: {
      ...features,
      text: {
        ...features?.text,
        containerPadding: '0px 0px 24px 0px',
        content: __('Headline'),
        defaultTextColor: true,
        horizontalAlign: 'left',
        lineHeight: theme
          ? convertRemToPx(parseFloat(theme.fontSizes[7])) * 1.5
          : undefined,
        textColor: '#000',
        textFontSize: theme
          ? convertRemToPx(parseFloat(theme.fontSizes[7]))
          : undefined,
        tied: true,
      },
    },
  });

  const subline = Text.item({
    ...props,
    features: {
      ...features,
      text: {
        ...features?.text,
        content: placeholder[placeholderIndex] || placeholder[1],
        containerPadding: '0px 0px 24px 0px',
        defaultTextColor: true,
        horizontalAlign: 'left',
        textColor: '#000',
        textFontSize: theme
          ? convertRemToPx(parseFloat(theme.fontSizes[2]))
          : undefined,
        tied: true,
      },
    },
  });

  const button = Button.item({
    ...props,
    features: {
      ...features,
      button: {
        ...features?.button,
        buttonPadding: '7px 16px 7px 16px',
        containerPadding: 0,
        hidden: false,
        horizontalAlign: 'left',
        mode: 'network',
        tied: true,
        variant: 'primary',
      },
    },
  });

  return [
    createNewItem(image),
    createNewItem({
      ...headline,
      attributes: {
        ...headline.attributes,
        ...headlineAttributesToApply,
      },
    }),
    createNewItem({
      ...subline,
      attributes: {
        ...subline.attributes,
        ...sublineAttributesToApply,
      },
    }),
    createNewItem({
      ...button,
      attributes: {
        ...button.attributes,
        ...buttonAttributesToApply,
      },
    }),
  ];
};
